import { useLayoutEffect } from "react";

import { Tooltip } from "@mui/material";

import { usePopup } from "@components/popup/popup_context";

export default function PopupLegend() {
  const { setOption, setActions, onClose } = usePopup();

  useLayoutEffect(() => {
    setOption({
      title: "범례",
      maxWidth: "700px"
    });
  }, []);

  return (
    <>
      <div className="popup-contents">
        <div className="legend-group">
          <p>STACKER</p>
          <div>
            <div>
              <p>작업상태</p>
              <div>
                <span><em className="error"></em>Disconnect</span>
                <span><em className="error"></em>Normal</span>
                <span><em className="error"></em>잠금</span>
                <span><em className="error"></em>에러내용</span>
              </div>
            </div>
            <div>
              <p>Carriage</p>
              <div>
                <span><em className="error"></em>작업없음</span>
                <span><em className="error"></em>출고작업</span>
                <span><em className="error"></em>입고작업</span>
                <span><em className="error"></em>에러내용</span>
              </div>
            </div>
            <div>
              <p>포크상태</p>
              <div>
                <span><i>■</i>Center</span>
                <span><i>▶</i>Right</span>
                <span><i>◀</i>Left</span>
              </div>
            </div>
            <div>
              <p>동작모드</p>
              <div>
                <span><em className="error"></em>수동모드</span>
                <span><em className="error"></em>반자동 모드</span>
                <span><em className="error"></em>자동모드</span>
                <span><em className="error"></em>Remote</span>
              </div>
            </div>
          </div>
          <p>CONVEYOR</p>
          <div>
            <div>
              <p>Luggage status</p>
              <div>
                <span><em className="error"></em>Disconnect</span>
                <span><em className="error"></em>Normal</span>
                <span><em className="error"></em>잠금</span>
                <span><em className="error"></em>에러내용</span>
              </div>
            </div>
            <div>
              <p>Conveyor status</p>
              <div>
                <span><em className="error"></em>작업없음</span>
                <span><em className="error"></em>출고작업</span>
                <span><em className="error"></em>입고작업</span>
                <span><em className="error"></em>에러내용</span>
              </div>
            </div>
            <div>
              <p>Forking signal</p>
              <div>
                <span><em className="error"></em>Enabled</span>
                <span><em className="error"></em>Disabled</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
